import { FC } from "react";
import LoadingSpinner from "./LoadingSpinner";

export const GlobalLoading: FC = () => {
  return (
    <div
      className="fixed inset-0 flex justify-center items-center bg-warm-white/95 z-[9999] select-none"
      data-testid="global-loading"
    >
      <div className="flex flex-col items-center">
        <LoadingSpinner size="99px" />
      </div>
    </div>
  );
};
